import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import FormInputField from 'src/components/common/formInputField';
import { useForm } from 'react-hook-form';
import { useSettingActions } from 'src/store/settings/actions';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from 'src/store/reducers/state';
import ToastMessage from 'src/components/ToastContainer';
import { successMsg } from 'src/components/utilities/utils';
import { errorMsg } from 'src/components/utilities/utils';
const WebCourseIntegration: React.FC = () => {
  const dispatch = useDispatch();
  const settingAction = useSettingActions(dispatch);
  const {
    register,
    formState: { errors },
    handleSubmit,
    reset
  } = useForm();

  const { isIntegrationUpdated, webCourseIntegration, message, error } = useSelector(
    (state: RootState) => {
      return {
        isIntegrationUpdated: state.setting.isIntegrationUpdated,
        webCourseIntegration: state.setting.webCourseIntegration,
        message: state.setting.message,
        error: state.setting.error
      };
    }
  );

  useEffect(() => {
    if (webCourseIntegration) {
      reset(webCourseIntegration);
    }
  }, [webCourseIntegration]);

  useEffect(() => {
    settingAction.getWebCourseIntegrationRequest();
  }, []);

  useEffect(() => {
    if (isIntegrationUpdated) {
      successMsg(message);
      settingAction.resetSettingStateRequest();
    }
  }, [isIntegrationUpdated]);

  const onSubmit = (data: any) => {
    const payloadData = {
      name: 'WebCourseworks',
      updateData: [
        { op: 'replace', path: 'secureToken', value: data.secureToken },
        { op: 'replace', path: 'webServiceUrl', value: data.webServiceUrl }
      ]
    };
    settingAction.updateIntegrationRequest(payloadData);
  };

  useEffect(() => {
    if (error) {
      errorMsg('Error');
      settingAction.resetSettingStateRequest();
    }
  }, [error]);

  return (
    <div>
      <ToastMessage />
      <div className="mb-6">
        <h2 className="font-semibold my-1">Integration</h2>
        <ol className="breadcrumb">
          <li>
            <Link to="/">Home</Link>
          </li>
          <li>
            <Link to="/integrations">Integration</Link>
          </li>
          <li>
            <strong> Web Courseworks Integration</strong>
          </li>
        </ol>
        <Link to={`/integrations`}>
          <i className="fas fa-arrow-left mt-5"></i>
          <span className="ml-2">Go Back</span>
        </Link>
      </div>
      <form onSubmit={handleSubmit(onSubmit)} className="dashboard-card p-5 w-5/6">
        <div className="md:flex items-center mb-3 mt-3">
          <div className="md:w-4/12">
            <label className="font-semibold">Web Service URL</label>
          </div>
          <div className="md:w-8/12">
            <FormInputField
              label={''}
              type={'text'}
              fieldName={'webServiceUrl'}
              register={register}
              errors={''}
              isRequired={false}
            />
          </div>
        </div>

        <div className="md:flex items-center mb-3 mt-3">
          <div className="md:w-4/12">
            <label className="font-semibold">Secure Token</label>
          </div>
          <div className="md:w-8/12">
            <FormInputField
              label={''}
              type={'text'}
              fieldName={'secureToken'}
              register={register}
              errors={''}
              isRequired={false}
            />
          </div>
        </div>

        <div className="flex items-center">
          <button type="submit" className="px-6 btn-primary w-28 mr-0 ml-3 mt-0">
            Save
          </button>
        </div>
      </form>
    </div>
  );
};

export default WebCourseIntegration;
